import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'

import {
    PlantCareListImage,
    PlantCareListItemContent,
    PlantCareItemName,
    PlantCareItemValue,
    PlantCareListItemInnerContent,
    PlantCareListItemCol,
    PlantCareListImageWrapper
} from '../StyledComponents/Plants/PlantCare'

const sunIcon = require('../../assets/images/CareIcons/008-sun-1.png')
const halfShadeIcon = require('../../assets/images/CareIcons/007-half-shadow.png')
const shadeIcon = require('../../assets/images/CareIcons/006-clouds.png')
const lowWaterDemandIcon = require('../../assets/images/CareIcons/LowWaterDemand.png')
const averageWaterDemandIcon = require('../../assets/images/CareIcons/AverageWaterDemand.png')
const highWaterDemandIcon = require('../../assets/images/CareIcons/005-drop.png')
const springIcon = require('../../assets/images/CareIcons/003-fields.png')
const summerIcon = require('../../assets/images/CareIcons/004-beach.png')
const winterIcon = require('../../assets/images/CareIcons/002-iceberg.png')
const autumnIcon = require('../../assets/images/CareIcons/001-cape.png')
const terrainIcon = require('../../assets/images/CareIcons/009-terrain.png')
const fertilizerIcon = require('../../assets/images/CareIcons/spray.svg')
const heightIcon = require('../../assets/images/CareIcons/height.svg')
const florescenceIcon = require('../../assets/images/CareIcons/flower.svg')
const unknownIcon = require('../../assets/images/CareIcons/question-mark-button.svg')

const mapIconToImageSrc = (value) => {
    if (!value) {
        return unknownIcon
    }
    switch (value) {
        case 'SUN':
            return sunIcon
        case 'HALF_SHADE':
            return halfShadeIcon
        case 'SHADE':
            return shadeIcon
        case 'HIGH':
            return highWaterDemandIcon
        case 'AVERAGE':
            return averageWaterDemandIcon
        case 'LOW':
            return lowWaterDemandIcon
        case 'SPRING':
            return springIcon
        case 'SUMMER':
            return summerIcon
        case 'AUTUMN':
            return autumnIcon
        case 'WINTER':
            return winterIcon
        case 'TERRAIN':
            return terrainIcon
        case 'FERTILIZER':
            return fertilizerIcon
        case 'HEIGHT':
            return heightIcon
        case 'FLORESCENSE':
            return florescenceIcon
        default:
            return unknownIcon
    }
}

class PlantCareEntry extends Component {
    render() {
        const { value, title, icon } = this.props

        const shownValue = value && !isEmpty(value) ? value : 'unbekannt'

        return (
            <PlantCareListItemCol xs="6" sm="4" md="3">
                <PlantCareListItemContent>
                    <PlantCareListImageWrapper>
                        <PlantCareListImage src={mapIconToImageSrc(icon)} contain />
                    </PlantCareListImageWrapper>
                    <PlantCareListItemInnerContent>
                        <PlantCareItemName>{title}</PlantCareItemName>
                        <PlantCareItemValue>{shownValue}</PlantCareItemValue>
                    </PlantCareListItemInnerContent>
                </PlantCareListItemContent>
            </PlantCareListItemCol>
        )
    }
}

export default PlantCareEntry



// WEBPACK FOOTER //
// ./src/components/Plant/PlantCareRow.js